/**
 * This module is included as part of the `yarn build:css` build process and changes to it will affect the output of `stylesheet.compiled.ts`.
 * You must run `yarn build:css` after any changes here as the build will fail if `stylesheet.compiled.ts` changes on CI.
 */

const grey = {
  darkest: "#031b4e",
  dark: "#5b6987",
  primary: "#8390af",
  light: "#e5e8ed",
  lightest: "#f3f5f9",
} as const;

/**
 * FIXME: This is not in the style guide and should probably be removed,
 * but not sure how.
 */
const shadesOfGrey = {
  9: "#444",
  8: "#676767",
  7: "#999",
  6: "#bbb",
  5: "#cbcbcb",
  4: "#dfdfdf",
  3: "#ececec",
  2: "#f1f1f1",
  1: "#fafafa",
} as const;

const purple = {
  primary: "#6355f8",
  light: "#9086fa",
  lightest: "#f7f6fe",
} as const;

const blue = {
  darkest: "#003f99",
  dark: "#0061eb",
  primary: "#3387ff",
  lightest: "#f3f8ff",
} as const;

const green = {
  darkest: "#0a4726",
  dark: "#127c43",
  primary: "#0aa653",
  lightest: "#f4f9f6",
} as const;

const red = {
  darkest: "#870808",
  dark: "#ca0c0c",
  primary: "#f44848",
  light: "#f77878",
  lightest: "#fef5f5",
} as const;

const orange = {
  primary: "#f56109",
  light: "#faa06a",
  lightest: "#fef8f4",
} as const;

const primary = {
  base: "#0069ff",
  hover: "#005fe6",
} as const;

const secondary = {
  base: "#127c43",
  hover: "#0aa653",
} as const;

const danger = {
  base: "#d91d1d",
  hover: "#c31a1a",
} as const;

const cli = {
  background: "#141b2e",
  highlight: "#2f3d5c", // FIXME: not in style guide
  purple: "#af86ff",
  orange: "#ff863e",
  blue: "#00c6ff",
  green: "#00d688",
} as const;

export const colors = {
  white: "#ffffff",
  black: "#000000",
  success: "#11a95e",
  primaryBackground: "#f5f9ff",
  backdrop: "rgba(243, 245, 249, 0.9)",
  muted: "rgba(51, 51, 51, 0.75)",

  /**
   * FIXME: this is not in the styleguide, but was previously being referenced as `colors.teams_7`.
   */
  searchHighlight: "#ffc001",
  shadesOfGrey,

  grey,
  purple,
  blue,
  green,
  red,
  orange,

  primary,
  secondary,
  danger,

  cli,
} as const;
